import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({
  children,
  delay = 0,
  y = 48,
  className = "",
  amount = 0.3,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 1.2, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.4 }}
  >
    <motion.span
      className="block will-change-transform"
      variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
      transition={{ duration: 1.3, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`text-[11px] font-sans font-medium uppercase tracking-[0.35em] ${
      light ? "text-ivory/70" : "text-olive"
    }`}
  >
    {children}
  </p>
);
